import { useEffect } from 'react'
import { usePostHog } from '@posthog/react'
import type { PostHog } from 'posthog-js'

const enablePostHogCapturing = (posthog: PostHog, withPrivacyAcceptedEvent: boolean) => {
  if (withPrivacyAcceptedEvent) {
    posthog.opt_in_capturing({
      captureEventName: 'Privacy Accepted',
      captureProperties: { source: 'Cookiebot consent' }
    })
  } else {
    posthog.opt_in_capturing()
  }
  posthog.startSessionRecording()
}

const disablePostHogCapturing = (posthog: PostHog) => {
  posthog.stopSessionRecording()
  posthog.opt_out_capturing()
}

export const usePostHogCookiebotConsent = (isAnalyticsProd: boolean) => {
  const posthog = usePostHog()
  useEffect(() => {
    // No need to check for consent in non-prod environments
    if (!isAnalyticsProd) {
      enablePostHogCapturing(posthog, false)
      return
    }

    try {
      const updatePostHogConsent = () => {
        const consent = (window as any).Cookiebot?.consent
        const hasStatisticsConsent = Boolean(consent?.statistics)

        if (hasStatisticsConsent) {
          enablePostHogCapturing(posthog, true)
        } else {
          disablePostHogCapturing(posthog)
        }
      }

      updatePostHogConsent()

      window.addEventListener('CookiebotOnConsentReady', updatePostHogConsent)
      window.addEventListener('CookiebotOnAccept', updatePostHogConsent)
      window.addEventListener('CookiebotOnDecline', updatePostHogConsent)

      return () => {
        window.removeEventListener('CookiebotOnConsentReady', updatePostHogConsent)
        window.removeEventListener('CookiebotOnAccept', updatePostHogConsent)
        window.removeEventListener('CookiebotOnDecline', updatePostHogConsent)
      }
    } catch (error) {
      console.log('Error in Cookiebot PostHog consent handler')
      console.log(error)
    }
  }, [isAnalyticsProd, posthog])
}
